import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../../services/authentication.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css', '../../master/masterpage.component.css']
})
export class HomeComponent implements OnInit {

  username = localStorage.getItem('userLogon');

  constructor(private authenticationService: AuthenticationService) { }

  get catchError(): string {
    if (this.authenticationService.errorMessage) {
      return `Falha ao carregar os itens do menu para o usuário. <br> ${this.authenticationService.errorMessage}`;
    }
  }

  ngOnInit() {
    document.title = 'Home';
  }

}
